import React from 'react';

interface ToolbarProps {
  children: React.ReactNode;
  classes?: string;
}

const Toolbar = ({ children, classes }: ToolbarProps) => {
  return <div className={`toolbar ${classes}`}>{children}</div>;
};

export default Toolbar;
